import ToolbarButton from './toolbar-button';
import ToolbarSaveButton from './toolbar-save-button';
import ToolbarLoadButton from './toolbar-load-button';
//import ToolbarFittingCounterButton from './toolbar-fittingCounter-button';
import Toolbar from './toolbar';

export { ToolbarButton, ToolbarSaveButton, ToolbarLoadButton,
//ToolbarFittingCounterButton,
Toolbar };

export default {
  ToolbarButton: ToolbarButton,
  ToolbarSaveButton: ToolbarSaveButton,
  ToolbarLoadButton: ToolbarLoadButton,
  //ToolbarFittingCounterButton,
  Toolbar: Toolbar
};